import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";

export const PROJECT_OPTIONS = [
  { value: "Moses", label: "The Moses Project" },
  { value: "Miriam", label: "The Miriam Project" },
];

export const projectName = (value) =>
  value === "Miriam" ? "The Miriam Project" : "The Moses Project";

export default function ProjectFilter({
  value,
  onChange,
  style,
  required = true,
}) {
  const selected = Array.isArray(value) ? value : [];
  const empty = selected.length === 0;
  return (
    <FormControl
      required={required}
      style={{ width: "100%", marginBottom: "20px", ...style }}
    >
      <InputLabel
        id="project-filter-label"
        shrink={required ? undefined : true}
      >
        Project Name
      </InputLabel>
      <Select
        multiple
        required={required}
        labelId="project-filter-label"
        id="project-filter"
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        input={<OutlinedInput label="Project Name" />}
        renderValue={(values) =>
          values.length > 0
            ? values.map(projectName).join(", ")
            : required
            ? ""
            : "All projects"
        }
      >
        {PROJECT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={selected.indexOf(option.value) > -1} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {required && empty && (
        <FormHelperText>Select at least one project</FormHelperText>
      )}
    </FormControl>
  );
}
